module.exports = __webpack_public_path__ + "static/media/complete-order.320406be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/complete-order.svg
// module id = 6346
// module chunks = 1